import { getContract, getContractById, getBid, postContract, getBidPrice, cancelContract, getContractDetailShipment, getContractOnGoing,
  extendContract, getBusinessAgreement, acceptBusinessAgreement, downloadBusinessAgreement,
  showAgreementContract, getContractFilter
} from '@/api/contract.api'

export const FETCH_CONTRACT = 'FETCH_CONTRACT'
export const FETCH_CONTRACT_LOADING = 'FETCH_CONTRACT_LOADING'
export const FETCH_CONTRACT_DONE = 'FETCH_CONTRACT_DONE'
export const FETCH_CONTRACT_ERROR = 'FETCH_CONTRACT_ERROR'

export const FETCH_CONTRACT_FILTER = 'FETCH_CONTRACT_FILTER'
export const FETCH_CONTRACT_FILTER_LOADING = 'FETCH_CONTRACT_FILTER_LOADING'
export const FETCH_CONTRACT_FILTER_DONE = 'FETCH_CONTRACT_FILTER_DONE'
export const FETCH_CONTRACT_FILTER_ERROR = 'FETCH_CONTRACT_FILTER_ERROR'

export const FETCH_CONTRACT_BY_ID = 'FETCH_CONTRACT_BY_ID'
export const FETCH_CONTRACT_BY_ID_LOADING = 'FETCH_CONTRACT_BY_ID_LOADING'
export const FETCH_CONTRACT_BY_ID_DONE = 'FETCH_CONTRACT_BY_ID_DONE'
export const FETCH_CONTRACT_BY_ID_ERROR = 'FETCH_CONTRACT_BY_ID_ERROR'

export const FETCH_BID_CONTRACT = 'FETCH_BID_CONTRACT'
export const FETCH_BID_CONTRACT_LOADING = 'FETCH_BID_CONTRACT_LOADING'
export const FETCH_BID_CONTRACT_DONE = 'FETCH_BID_CONTRACT_DONE'
export const FETCH_BID_CONTRACT_ERROR = 'FETCH_BID_CONTRACT_ERROR'

export const CREATE_CONTRACT = 'CREATE_CONTRACT'
export const CREATE_CONTRACT_LOADING = 'CREATE_CONTRACT_LOADING'
export const CREATE_CONTRACT_DONE = 'CREATE_CONTRACT_DONE'
export const CREATE_CONTRACT_ERROR = 'CREATE_CONTRACT_ERROR'

export const FETCH_BID_PRICE = 'FETCH_BID_PRICE'
export const FETCH_BID_PRICE_LOADING = 'FETCH_BID_PRICE_LOADING'
export const FETCH_BID_PRICE_DONE = 'FETCH_BID_PRICE_DONE'
export const FETCH_BID_PRICE_ERROR = 'FETCH_BID_PRICE_ERROR'

export const CANCEL_CONTRACT = 'CANCEL_CONTRACT'
export const CANCEL_CONTRACT_LOADING = 'CANCEL_CONTRACT_LOADING'
export const CANCEL_CONTRACT_DONE = 'CANCEL_CONTRACT_DONE'
export const CANCEL_CONTRACT_ERROR = 'CANCEL_CONTRACT_ERROR'

export const GET_CONTRACT_DETAIL = 'GET_CONTRACT_DETAIL'
export const GET_CONTRACT_DETAIL_LOADING = 'GET_CONTRACT_DETAIL_LOADING'
export const GET_CONTRACT_DETAIL_DONE = 'GET_CONTRACT_DETAIL_DONE'
export const GET_CONTRACT_DETAIL_ERROR = 'GET_CONTRACT_DETAIL_ERROR'

export const GET_SHIPMENT_ONGOING = 'GET_SHIPMENT_ONGOING'
export const GET_SHIPMENT_ONGOING_LOADING = 'GET_SHIPMENT_ONGOING_LOADING'
export const GET_SHIPMENT_ONGOING_DONE = 'GET_SHIPMENT_ONGOING_DONE'
export const GET_SHIPMENT_ONGOING_ERROR = 'GET_SHIPMENT_ONGOING_ERROR'

export const EXTEND_CONTRACT = 'EXTEND_CONTRACT'
export const EXTEND_CONTRACT_LOADING = 'EXTEND_CONTRACT_LOADING'
export const EXTEND_CONTRACT_DONE = 'EXTEND_CONTRACT_DONE'
export const EXTEND_CONTRACT_ERROR = 'EXTEND_CONTRACT_ERROR'

export const GET_BUSINESS_AGREEMENT = 'GET_BUSINESS_AGREEMENT'
export const GET_BUSINESS_AGREEMENT_LOADING = 'GET_BUSINESS_AGREEMENT_LOADING'
export const GET_BUSINESS_AGREEMENT_DONE = 'GET_BUSINESS_AGREEMENT_DONE'
export const GET_BUSINESS_AGREEMENT_ERROR = 'GET_BUSINESS_AGREEMENT_ERROR'

export const ACCEPT_BUSINESS_AGREEMENT = 'ACCEPT_BUSINESS_AGREEMENT'
export const ACCEPT_BUSINESS_AGREEMENT_LOADING = 'ACCEPT_BUSINESS_AGREEMENT_LOADING'
export const ACCEPT_BUSINESS_AGREEMENT_DONE = 'ACCEPT_BUSINESS_AGREEMENT_DONE'
export const ACCEPT_BUSINESS_AGREEMENT_ERROR = 'ACCEPT_BUSINESS_AGREEMENT_ERROR'

export const DOWNLOAD_BUSINESS_AGREEMENT = 'DOWNLOAD_BUSINESS_AGREEMENT'
export const DOWNLOAD_BUSINESS_AGREEMENT_LOADING = 'DOWNLOAD_BUSINESS_AGREEMENT_LOADING'
export const DOWNLOAD_BUSINESS_AGREEMENT_DONE = 'DOWNLOAD_BUSINESS_AGREEMENT_DONE'
export const DOWNLOAD_BUSINESS_AGREEMENT_ERROR = 'DOWNLOAD_BUSINESS_AGREEMENT_ERROR'

export const SHOW_AGREEMENT_CTC = 'SHOW_AGREEMENT_CTC'
export const SHOW_AGREEMENT_CTC_LOADING = 'SHOW_AGREEMENT_CTC_LOADING'
export const SHOW_AGREEMENT_CTC_DONE = 'SHOW_AGREEMENT_CTC_DONE'
export const SHOW_AGREEMENT_CTC_ERROR = 'SHOW_AGREEMENT_CTC_ERROR'

export default {
  [FETCH_CONTRACT] (context, {type, currentPage, perPage}) {
    context.commit(FETCH_CONTRACT_LOADING)
    return getContract(currentPage, type, perPage)
      .then((response) => {
        context.commit(FETCH_CONTRACT_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_CONTRACT_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_CONTRACT_FILTER] (context, {payload, perPage}) {
    context.commit(FETCH_CONTRACT_FILTER_LOADING)
    return getContractFilter(payload.page, payload.type, perPage, payload.filter, payload.key)
      .then((response) => {
        context.commit(FETCH_CONTRACT_FILTER_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_CONTRACT_FILTER_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_CONTRACT_BY_ID] (context, id) {
    context.commit(FETCH_CONTRACT_BY_ID_LOADING)
    return getContractById(id)
      .then((response) => {
        context.commit(FETCH_CONTRACT_BY_ID_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_CONTRACT_BY_ID_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_BID_CONTRACT] (context, id) {
    context.commit(FETCH_BID_CONTRACT_LOADING)
    return getBid(id)
      .then((response) => {
        context.commit(FETCH_BID_CONTRACT_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_BID_CONTRACT_ERROR, error)
        console.error(error)
      })
  },

  [CREATE_CONTRACT] (context, payload) {
    context.commit(CREATE_CONTRACT_LOADING)
    return postContract(payload)
      .then((response) => {
        context.commit(CREATE_CONTRACT_DONE, response)
      })
      .catch((error) => {
        context.commit(CREATE_CONTRACT_ERROR, error)
      })
  },

  [FETCH_BID_PRICE] (context, id) {
    context.commit(FETCH_BID_PRICE_LOADING)
    return getBidPrice(id)
      .then((response) => {
        context.commit(FETCH_BID_PRICE_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_BID_PRICE_ERROR, error)
        console.error(error)
      })
  },

  [CANCEL_CONTRACT] (context, {id}) {
    context.commit(CANCEL_CONTRACT_LOADING)
    return cancelContract({id})
      .then((response) => {
        return context.commit(CANCEL_CONTRACT_DONE, response)
      })
      .catch((error) => {
        context.commit(CANCEL_CONTRACT_ERROR, error)
      })
  },

  [GET_CONTRACT_DETAIL] (context, id) {
    context.commit(GET_CONTRACT_DETAIL_LOADING)
    return getContractDetailShipment(id)
      .then((response) => {
        context.commit(GET_CONTRACT_DETAIL_DONE, response)
      })
      .catch((error) => {
        context.commit(GET_CONTRACT_DETAIL_ERROR, error)
      })
  },

  [GET_SHIPMENT_ONGOING] (context, id) {
    context.commit(GET_SHIPMENT_ONGOING_LOADING)
    return getContractOnGoing(id)
      .then((response) => {
        context.commit(GET_SHIPMENT_ONGOING_DONE, response)
      })
      .catch((error) => {
        context.commit(GET_SHIPMENT_ONGOING_ERROR, error)
      })
  },

  [EXTEND_CONTRACT] (context, payload) {
    context.commit(EXTEND_CONTRACT_LOADING)
    return extendContract(payload)
      .then((response) => {
        context.commit(EXTEND_CONTRACT_DONE, response)
      })
      .catch((error) => {
        context.commit(EXTEND_CONTRACT_ERROR, error)
        console.error(error)
      })
  },

  [GET_BUSINESS_AGREEMENT] (context, {id, bidId}) {
    context.commit(GET_BUSINESS_AGREEMENT_LOADING)
    return getBusinessAgreement({id, bidId})
      .then((response) => {
        context.commit(GET_BUSINESS_AGREEMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(GET_BUSINESS_AGREEMENT_ERROR, error)
        console.error(error)
      })
  },

  [ACCEPT_BUSINESS_AGREEMENT] (context, {id, payload}) {
    context.commit(ACCEPT_BUSINESS_AGREEMENT_LOADING)
    return acceptBusinessAgreement(id, payload)
      .then((response) => {
        context.commit(ACCEPT_BUSINESS_AGREEMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(ACCEPT_BUSINESS_AGREEMENT_ERROR, error)
        console.error(error)
      })
  },

  [DOWNLOAD_BUSINESS_AGREEMENT] (context, {id, fileName, bidId}) {
    context.commit(DOWNLOAD_BUSINESS_AGREEMENT_LOADING)
    return downloadBusinessAgreement(id, fileName, bidId)
      .then((response) => {
        context.commit(DOWNLOAD_BUSINESS_AGREEMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(DOWNLOAD_BUSINESS_AGREEMENT_ERROR, error)
      })
  },

  [SHOW_AGREEMENT_CTC] (context, {shipmentId, contractNumber, type, fileName, fileCategory, fileId}) {
    context.commit(SHOW_AGREEMENT_CTC_LOADING)
    return showAgreementContract({shipmentId, contractNumber, type, fileName, fileCategory, fileId})
      .then((response) => {
        context.commit(SHOW_AGREEMENT_CTC_DONE, response)
      })
      .catch((error) => {
        context.commit(SHOW_AGREEMENT_CTC_ERROR, true)
        console.error(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/contract/actions.js